<template>
  <v-menu
    ref="menu"
    :close-on-content-click="false"
    v-model="menu"
    :return-value.sync="date"
    :nudge-right="40"
    transition="scale-transition"
    offset-y
    full-width
    min-width="290px"
  >
    <v-text-field
      slot="activator"
      :value="formatDate"
      :label="label"
      :readonly="editable"
      :clearable="clearable"
      append-icon="event"
      @input="inputText"
      :error-messages="errorMessages"
      placeholder="dd/mm/aaaa"
      :rules="rules"
    ></v-text-field>

    <v-date-picker
      v-if="!readonly"
      v-model="date"
      locale="es-ES"
      scrollable
      @change="change"
      :min="min"
      :max="max"
    >
      <v-spacer></v-spacer>
      <v-btn flat color="primary" @click="cancel(date)">
        {{ $t('message.cancel') }}
      </v-btn>
      <v-btn flat color="primary" @click="save(date)">
        {{ $t('message.ok') }}
      </v-btn>
    </v-date-picker>
  </v-menu>
</template>
<script>
export default {
  props: {
    label: { type: String, default: '' },
    value: { type: String, default: '' },
    min: { type: String, default: '' },
    max: { type: String, default: '' },
    clearable: { type: Boolean, default: false },
    errorMessages: {},
    readonly: { type: Boolean, default: false },
    editable: { type: Boolean, default: true },
    rules: { type: Array },
  },
  data: () => ({
    menu: false,
    date: undefined,
    //initValue: value
  }),
  watch: {
    value(value) {
      this.date = value
      this.$emit('input', value)
    },
  },
  computed: {
    formatDate() {
      if (!this.date) return undefined
      const [year, month, day] = this.date.split('-')
      return `${day}/${month}/${year}`
    },
  },
  methods: {
    change(){
        this.$emit('change')
    },
    inputText(val){
        this.$emit('input',val)
    },
    save(date) {
      this.$refs.menu.save(date)
      this.$emit('input', date)
      this.$emit('changeSave')
    },
    // eslint-disable-next-line no-unused-vars
    cancel(value) {
      this.date = this.value
      this.menu = false
    },
  },
}
</script>
